import React, { useState } from "react";
import dayjs from "dayjs";
import moment from "moment/moment";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrBefore);

const Calendar = ({ events = [] }) => {
  const [currentDate, setCurrentDate] = useState(dayjs());
  const today = dayjs();

  const monthStart = currentDate.startOf("month");
  const monthEnd = currentDate.endOf("month");
  const startDate = monthStart.startOf("week"); // Monday
  const endDate = monthEnd.endOf("week");

  const days = [];
  let day = startDate;

  while (day.isSameOrBefore(endDate, "day")) {
    days.push(day);
    day = day.add(1, "day");
  }

  const prevMonth = () => setCurrentDate(currentDate.subtract(1, "month"));
  const nextMonth = () => setCurrentDate(currentDate.add(1, "month"));

  // Create a lookup for quick access
  const eventMap = events.reduce((acc, ev) => {
    acc[ev.holiday_date] = ev;
    return acc;
  }, {});

  return (
    <div className="relative w-full max-w-sm bg-white rounded-xl border border-[#a48572]/10 shadow p-4">
      {/* Month Header */}
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm font-medium text-[#de2b26]">
          {currentDate.format("MMMM YYYY")}
        </p>
        <div className="flex items-center gap-4">
          <button onClick={prevMonth} className="p-1 rounded hover:bg-gray-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-[#de2b26]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button onClick={nextMonth} className="p-1 rounded hover:bg-gray-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-[#de2b26]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Weekday Header */}
      <div className="grid grid-cols-7 text-center text-sm font-medium text-[#142b70]">
        <div>Su</div>
        <div>Mo</div>
        <div>Tu</div>
        <div>We</div>
        <div>Th</div>
        <div>Fr</div>
        <div>Sa</div>
      </div>

      {/* Calendar Grid */}
      <div className="grid grid-cols-7 gap-2 mt-2 text-xs">
        {days.map((day, i) => {
          const isCurrentMonth = day.month() === currentDate.month();
          const formatted = day.format("YYYY-MM-DD");
          const event = eventMap[formatted];
          const isSunday = day.day() === 0; // Sunday
          const isToday = today.isSame(day, "day");

          return (
            <div
              key={i}
              className={`relative group flex items-center justify-center w-10 h-10 rounded-full cursor-pointer
                ${isCurrentMonth ? "text-[#142b70]" : "text-gray-300"}
                ${event ? "bg-[#f5e3d3] font-semibold" : ""}
                ${isSunday ? "text-gray-400 opacity-50 cursor-not-allowed" : ""}
                ${isToday ? "border-2 border-[#de2b26] font-bold" : ""}
              `}
            >
              {day.date()}

              {/* Tooltip */}
              {event?.title && (
                <div className="absolute bottom-12 left-1/2 -translate-x-1/2 hidden group-hover:block bg-black text-white text-xs px-2 py-1 rounded shadow">
                  {event.title}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
